<div class="mt-2"></div>
<div class="mt-2">
  <div class="row">
    <div class="col-md-10 mt-3 w-100">
      <h4 class="title"><i class="fas fa-hand-holding-usd"></i> {{title | translate}}</h4>
    </div>
    <div class="col-md-2 mt-3">
    </div>
  </div>
</div>
<div>
  <div class="row mt-2">
    <div class="col-md-3 custom-mr-17" *ngIf="hasRole(ROLE_SUPERADMIN)">
      <label class="font-weight-bold custom-width-input">{{ "LABEL.PARTNER" | translate }}:</label>
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fas fa-university"></i></div>
        </div>
        <select *ngIf="hasRole(ROLE_SUPERADMIN)"
                class="form-control"
                [(ngModel)]="partnerSelected"
                (ngModelChange)="reloadEnterprises()">
          <option *ngFor="let partner of partners" [ngValue]="partner">{{partner.name | translate}}</option>
        </select>
      </div>
    </div>
    <div class="col-md-2 custom-mr-17">
      <label class="font-weight-bold">{{ "LABEL.RANK" | translate }}:</label>
      <div class="input-group">
        <div class="input-group">
          <input name="datepicker"
                 class="form-control  input-form-date"
                 ngbDatepicker
                 #dpFromDate
                 #datepicker="ngbDatepicker"
                 [autoClose]="'outside'"
                 (dateSelect)="onDateSelection($event)"
                 [displayMonths]="2"
                 [dayTemplate]="t"
                 outsideDays="hidden"
                 [startDate]="fromDate!"
                 tabindex="-1"
                 [value]="formatter.format(fromDate)"
                 (input)="fromDate = validateInput(fromDate, dpFromDate.value)">
          <ng-template #t let-date let-focused="focused">
        <span class="custom-day"
              [class.focused]="focused"
              [class.range]="isRange(date)"
              [class.faded]="isHovered(date) || isInside(date)"
              (mouseenter)="hoveredDate = date"
              (mouseleave)="hoveredDate = null">
          {{ date.day }}
        </span>
          </ng-template>
          <div class="input-group-append">
          <span class="btn btn-outline-success mr-rigth" (click)="datepicker.toggle()" type="button">
            <i class="fa  fa-calendar-alt"></i>
          </span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-2 custom-mt-24 custom-mr-17">
      <div class="cw-100">
        <div class="input-group cmt-2">
          <input #dpToDate
                 class="form-control input-form-date" placeholder="dd-mm-yyyy"
                 name="dpToDate"
                 [value]="formatter.format(toDate)"
                 (input)="toDate = validateInput(toDate, dpToDate.value)">
          <div class="input-group-append">
          <span class="btn btn-outline-success" (click)="datepicker.toggle()" type="button">
            <i class="fa  fa-calendar-alt"></i>
          </span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-1 custom-mt-24 custom-mr-17">
      <button type="button" class="btn btn-outline-success btn-width-100"
              (click)="search()">
        <i class="fa fa-search"></i> {{ "BUTTON.SEARCH" | translate }}</button>
    </div>
  </div>
  <div class="table-responsive mt-2 mb-2 custom-table-height">
    <table class="table-sm custom-table">
      <thead>
      <tr>
        <th scope="col" title="#"></th>
        <th scope="col" title="{{'TABLE.HEADER.ENTERPRISE' | translate }}"></th>
        <th scope="col" title="{{'TABLE.HEADER.APPLICANT' | translate }}"></th>
        <th scope="col" title="{{'TABLE.HEADER.QUANTITY-IOF' | translate }}"></th>
        <th scope="col" title="{{'TABLE.HEADER.PRICE' | translate }}"></th>
        <th scope="col" title="{{'TABLE.HEADER.DATE' | translate }}"></th>
        <th scope="col" title="{{'TABLE.HEADER.STATE' | translate }}"></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let balancepurchase of balancepurchases; let index=index">
        <td title="#" ><b>{{(page.number * 10) + index + 1}}</b></td>
        <td title="{{'TABLE.HEADER.ENTERPRISE' | translate }}">{{balancepurchase.enterpriseName }}</td>
        <td title="{{'TABLE.HEADER.APPLICANT' | translate }}">{{balancepurchase.applicantFullname}}</td>
        <td title="{{'TABLE.HEADER.QUANTITY-IOF' | translate }}">{{balancepurchase.quantity}}</td>
        <td title="{{'TABLE.HEADER.PRICE' | translate }}">{{balancepurchase.price.toFixed(2)}}</td>
        <td title="{{'TABLE.HEADER.DATE' | translate }}">{{balancepurchase.createAt | dateformat}}</td>
        <td title="{{'TABLE.HEADER.STATE' | translate }}"><span
          class="{{!balancepurchase.active? 'badge badge-danger':''}}">{{balancepurchase.active ? 'Activo' : 'Inactivo'}}</span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <nav class="Page navigation pagination-custom">
    <div class="row">
      <div class="col-md-8 mt-1">
        <div class="justify-content-row">
          <span class="mr-1 font-weight-normal">Mostrar </span>
          <select class="mr-1 br-6 form-control-sm" [(ngModel)]="pageNumber"
                  (ngModelChange)="getBalancepurchase(enumPage.First)">
            <option *ngFor="let page of pageNumbers" [value]="page.value"
                    class="font-weight-bold">{{page.value}}</option>
          </select>
          <span class="font-weight-normal"> registros.</span>
        </div>
        <div class="page-total-entries">
          {{ "LABEL.TOTAL-RECORDS" | translate }}
          : {{balancepurchases.length + (page.number * page.size)}} {{ "LABEL.OF" | translate }} {{page.totalElements}}
        </div>
      </div>
      <div class="col-md-4">
        <ul class="pagination justify-content-end text-center">
          <li class="page-item btn-paged-ends cursor-pointer {{page.number === 0 ? 'disabled' : ''}}">
            <a class="prev {{page.number === 0 ? 'disabled' : ''}}" (click)="getBalancepurchase(enumPage.First)"
               tabindex="-1" aria-disabled="true">
              <i class=" fa fa-angle-double-left" aria-hidden="true"></i>
              {{ "BUTTON.FIRST" | translate }}
            </a>
          </li>
          <li class="cursor-pointer {{page.number == 0 ? 'disabled' : ''}}">
            <a class="left" (click)="getBalancepurchase(enumPage.Previous)">
              <i class="fa fa-angle-left" aria-hidden="true"></i></a>
          </li>
          <li class="cursor-pointer {{page.number === (page.totalPages - 1) || page.totalPages === 0 ? 'disabled':''}}">
            <a class="right" (click)="getBalancepurchase(enumPage.Next)"><i
              class="fa fa-angle-right" aria-hidden="true"></i></a>
          </li>
          <li class="cursor-pointer {{page.number === (page.totalPages - 1) || page.totalPages === 0 ? 'disabled':''}}"
              (click)="getBalancepurchase(enumPage.Last)">
            <a class="next">
              {{ "BUTTON.LAST" | translate }}
              <i class="fa fa-angle-double-right" aria-hidden="true"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</div>
<app-loading *ngIf="loading"></app-loading>
